import React from "react";
import "./tweet.css";
import TweetEmbed from "react-tweet-embed";
import "./rights.css";

function Rights() {
  return (
    <div
      style={{ padding: "0.3rem" }}
      id="rights"
      className="right"
    >
      <h1 style={{ margin: "2rem 0", textAlign: "center" }}>LGBTQ Rights</h1>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/3.1.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              As we welcome the 75th Year of Independence, lets make freedom,
              liberty & dignity core value of our society. Excited to speak at
              NSS -University of Petroleum and Energy Studies Dehradun,
              Uttarakhand this Saturday on LGBTRights, Diversity & Inclusion
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/3.2.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              Berlin's Catholic archbishop to appoint 'minister for gays'<br /> <br />
              https://t.co/ryq3k9wPQM?amp=1
            </h5>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", margin: "2rem 0" }}>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
            marginRight: "2rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/3.3.jpg"}></img>
          <div>
            <h5 style={{ color: "whitesmoke" }}>
              <br />Schitt’s Creeks Dan Levy thanks 'extremely generous' fans for
              incredible birthday gift<br /><br /> https://t.co/K6TXh4MHKl?amp=1
            </h5>
            {/* <h6 style={{ marginLeft: "20rem", color: "whitesmoke" }}>
              ~ Brian Kiely
            </h6> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            backgroundColor: "black",
            width: "fit-content",
            padding: "0.5rem",
            borderRadius: "12px",
            width: "45rem",
          }}
        >
          <img className="pic1" src={process.env.PUBLIC_URL + "/3.4.jpg"}></img>
          <div style={{ margin: "2rem 0" }}>
            <h5 style={{ color: "whitesmoke" }}>
              More Than 90% of LGBTQ+ U.S. Adults Have Received a COVID-19
              Vaccine<br /><br /> https://t.co/81jC797z3V?amp=1
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Rights;
